<!-- eslint-disable vue/html-self-closing -->
<template>
  <section class="gf-company-card">
    <gf-entity-card :description="company?.description">
      <template #headerTitle>
        <img
          class="avatar"
          :src="company?.avatar"
        />
        <div class="gf-company-card__header">
          <div class="info">
            <div class="title">
              <h6 class="mb-0">
                <a :href="companyLink">
                  {{ company?.title }}
                </a>
              </h6>
              <gf-verification-icon
                v-if="company.isVerified"
                verification-type="DEFAULT"
                size="3"
              />
            </div>
            <span
              v-if="company?.private"
              class="project-badge"
            >
              {{ $t('company.private') }}
            </span>
          </div>
          <small class="text-muted">
            <i class="gf-icon gf-icon-history gf-fs-2 mr-1"></i>
            {{ $t('company.registrationDate', { date: company?.createdAt }) }}
          </small>
        </div>
      </template>
      <template
        v-if="
          (!showYouOwnerLabel || !company?.isOwner) &&
          company?.description?.length === 0 &&
          !company?.url
        "
        #additionalActions
      >
        <div class="gf-company-card__footer-actions">
          <div class="gf-company-card__footer-actions">
            <div class="gf-company-card__star">
              <button
                class="btn btn-sm"
                type="button"
                @click="starCompany"
              >
                <i
                  class="gf-icon mr-1 gf-fs-2"
                  :class="starIconClass"
                ></i>
                <small>{{ starText }}</small>
              </button>
              <span
                class="project-badge"
                :class="{ '--starred': isStarredModel }"
              >
                {{ formatOutputNumber(starsCounterModel) }}
              </span>
            </div>
            <button
              class="btn btn-sm gf-tooltip-temporary"
              type="button"
              :class="{ '--show-tooltip': showCopyTooltip }"
              data-tooltip-text="Скопировано!"
              @click="shareCompany"
            >
              <i
                class="gf-icon gf-fs-2"
                :class="shareFieldIcon"
              ></i>
            </button>
          </div>
        </div>
      </template>
      <template
        v-if="company?.canLeave || company?.canReport"
        #dropdownActions
      >
        <button
          v-if="company?.canLeave"
          class="dropdown-item f5"
          type="button"
          @click="leaveCompany"
        >
          <i class="gf-icon gf-icon-logout mr-1"></i>
          {{ $t('company.leave.title') }}
        </button>
        <button
          v-if="company?.canReport"
          class="dropdown-item f5"
          type="button"
          @click="reportCompany"
        >
          <i class="gf-icon gf-icon-alert mr-1"></i>
          {{ $t('message.report') }}
        </button>
      </template>
      <template
        #footerContent
        v-if="company?.url?.length > 0 || (showYouOwnerLabel && company?.isOwner)"
      >
        <div class="gf-company-card__footer-content">
          <span
            v-if="company?.url"
            class="project-badge company-link"
          >
            <i class="gf-icon gf-icon-arrow-outward mr-1"></i>
            <a
              :href="company.url"
              target="_blank"
            >
              {{ shortCompanyUrl }}
            </a>
          </span>
          <span
            v-if="showYouOwnerLabel && company?.isOwner"
            class="gf-owner-badge"
          >
            <i class="gf-icon gf-icon-person mr-1"></i>
            {{ $t('company.youAreOwner') }}
          </span>
        </div>
      </template>
      <template
        #footerActions
        v-if="
          (showYouOwnerLabel && company?.isOwner) ||
          company?.description?.length > 0 ||
          company?.url?.length > 0
        "
      >
        <div class="gf-company-card__footer-actions">
          <div class="gf-company-card__star">
            <button
              class="btn btn-sm"
              type="button"
              @click="starCompany"
            >
              <i
                class="gf-icon mr-1 gf-fs-2"
                :class="starIconClass"
              ></i>
              <small>{{ starText }}</small>
            </button>
            <span
              class="project-badge"
              :class="{ '--starred': isStarredModel }"
            >
              {{ formatOutputNumber(starsCounterModel) }}
            </span>
          </div>
          <button
            class="btn btn-sm gf-tooltip-temporary"
            type="button"
            :class="{ '--show-tooltip': showCopyTooltip }"
            data-tooltip-text="Скопировано!"
            @click="shareCompany"
          >
            <i
              class="gf-icon gf-fs-2"
              :class="shareFieldIcon"
            ></i>
          </button>
        </div>
      </template>
      <template #mobileFooterActions>
        <div class="gf-company-card__footer-actions --mobile">
          <button
            class="btn btn-sm star-button"
            type="button"
            :class="{ '--starred': isStarredModel }"
            @click="starCompany"
          >
            <i
              class="gf-icon mr-1"
              :class="starIconMobileClass"
            ></i>
            <small>{{ formatOutputNumber(starsCounterModel) }}</small>
          </button>
          <button
            class="btn btn-sm gf-tooltip-temporary"
            type="button"
            :class="{ '--show-tooltip': showCopyTooltip }"
            data-tooltip-text="Скопировано!"
            @click="shareCompany"
          >
            <i
              class="gf-icon"
              :class="shareFieldIcon"
            ></i>
          </button>
        </div>
      </template>
    </gf-entity-card>
  </section>
</template>

<script>
import GfEntityCard from '@shared/shared-components/shared/GfEntityCard';
import HelperS from '@shared/services/helper.service';
import GfVerificationIcon from '@shared/shared-components/shared/GfVerificationIcon';
import CompanyMessages from '@/shared-modules/modules/company/company.messages';

export default {
  name: 'GfCompanyCard',
  components: { GfEntityCard, GfVerificationIcon },
  props: {
    company: {
      type: Object,
      default() {
        return {};
      }
    },
    showYouOwnerLabel: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      shareFieldIcon: 'gf-icon-share-social',
      isStarredModel: false,
      starsCounterModel: 0,
      showCopyTooltip: false
    };
  },
  computed: {
    companyLink() {
      return `/company/${this.company?.alias}`;
    },
    shortCompanyUrl() {
      return this.company?.url?.replace(/(^\w+:|^)\/\//, '');
    },
    starIconClass() {
      return this.isStarredModel ? 'gf-icon-star-fill text-warning' : 'gf-icon-star';
    },
    starText() {
      return this.isStarredModel ? this.$t('company.isStarred') : this.$t('company.addStarred');
    },
    starIconMobileClass() {
      return this.isStarredModel ? 'gf-icon-star-fill' : 'gf-icon-star text-muted';
    }
  },
  mounted() {
    this.isStarredModel = this.company.isStarred;
    this.starsCounterModel = this.company.starsCount || 0;
  },
  methods: {
    starCompany() {
      if (this.isStarredModel) this.starsCounterModel -= 1;
      else this.starsCounterModel += 1;
      this.$emit('star', { ...this.company, isStarred: this.isStarredModel });
      this.isStarredModel = !this.isStarredModel;
    },
    shareCompany() {
      const shareData = {
        title: this.$t('company.inGitflic', { title: this.company.title }),
        url: this.companyLink
      };
      if (!HelperS.share(shareData)) {
        this.shareFieldIcon = 'gf-icon-check';
        this.showCopyTooltip = true;
        setTimeout(() => {
          this.showCopyTooltip = false;
          this.shareFieldIcon = 'gf-icon-share-social';
        }, 1500);
      }
    },
    leaveCompany() {
      this.$emit('leave', this.company);
    },
    reportCompany() {
      this.$emit('report', this.company);
    },
    formatOutputNumber(number) {
      return HelperS.formatOutputNumber(number, 0);
    }
  },
  i18n: {
    messages: CompanyMessages
  }
};
</script>

<style lang="scss">
$this: '.gf-company-card';

#{$this} {
  #{$this}__header {
    width: calc(100% - 58px);
    display: flex;
    flex-direction: column;
    gap: 4px;

    & .info {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  #{$this}__footer-content {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;

    & .company-link a {
      max-width: 150px;
      text-decoration: underline;
      text-wrap: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    & > span {
      flex-wrap: wrap;
    }
  }
  #{$this}__footer-actions {
    display: flex;
    text-wrap: nowrap;
    gap: 8px;

    & button {
      & > i {
        font-size: 14px !important;
      }
    }

    #{$this}__star {
      display: flex;
      align-items: center;
      gap: 2px;

      & .project-badge.--starred {
        color: #000;
        background-color: var(--warning);
      }
    }

    &.--mobile {
      & > button {
        min-height: 32px !important;
        padding: 8px;
        background-color: var(--bg-light);
        border-radius: 6px;

        &.star-button {
          &.--starred {
            background-color: var(--warning);
            color: var(--light);
          }
        }

        &:hover {
          background-color: var(--bg-light-selected);
        }
      }
    }

    & button {
      min-height: 22px;
      padding: 0px 2px;

      &:focus {
        box-shadow: none;
      }
    }
  }
}
</style>
